import { useRef } from 'react';
import { Button, Modal, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { searchStorage } from '../store/api/StorageApi';
import { Search } from 'react-bootstrap-icons';
import { setStoragePoup } from '../store/api/Modals';
import {X} from "react-bootstrap-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
const ModalSearchStorage = () => {
    const searchData = useRef();
    const dispatch = useDispatch();
    const storageList = useSelector(state => state.ProductReducer.storageList);
    const popup = useSelector(state => state.popup.popupStorage);
    const { show, onSelect } = popup;
    const close = () => {
        if(onSelect)
        {
            onSelect(null);
        }
        dispatch(setStoragePoup({ show: false }));
    };
    const search = () => {
        dispatch(searchStorage(searchData.current.value, 10));
    }
    const select =(item)=>{
        if(onSelect)
        {
            onSelect(item);
            dispatch(setStoragePoup({ show: false }));
        }
    }
    return (
        <Modal show={show === true} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>انتخاب انبار<FontAwesomeIcon icon={faTimes}  size="lg" onClick={close}/></Modal.Header>
            <Modal.Body className='bodyStyle' style={{ paddingTop: "2px" }}>

                <div className="form-group mt-1">
                    <input type="text" ref={searchData} className="form-control" placeholder="نام انبار" style={{ display: "inline-block", width: "84%" }} onChange={e => searchData.current.Name = e.target.value} />
                    <Button className="group-Btn mt-1" style={{ position: "absolute" }} onClick={search}><Search size={18} /></Button>
                </div>
                {storageList &&
                    <Table className="mt-2">
                        <thead>
                            <tr>
                                <th style={{ display: "none" }}></th>
                                <th>نام انبار</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(storageList?.Data) && storageList.Data.map((item, i) => {
                                return (
                                <tr key={i} className="resultTableRow" onClick={()=>select(item)}>
                                    <td style={{ display: "none" }}></td>
                                    <td>{item.StorageName}</td>
                                </tr>)
                            }
                            )}
                        </tbody>
                    </Table>
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalSearchStorage;